<template>
  <v-flex md12>
    <v-flex pb-3>
      <h3>
        Terms and Conditions 条款及条件
      </h3>
    </v-flex>
    <v-flex>
      Embalming results may vary depending on the condition of the deceased. 遗体修复和定妆因⼈⽽异。
    </v-flex>
    <v-flex>
      Items listed are not exchangeable or refundable for cash. ⽆论在任何情况下，所购契约不能退回或对换成现⾦。
    </v-flex>
    <v-flex>
      Full payment to be collected on the final day of the funeral. 礼仪结束后，必须交付所购契约的价格。
    </v-flex>
    <v-flex>
      Use of parlour subject to availability. 追思礼堂使⽤悉视其屈时供应的情况⽽定。
    </v-flex>
    <v-flex>
      Package excludes burial plots, niches and tombstone. 此契约不包括福地,⻣灰神主牌位及墓碑。
    </v-flex>
    <v-flex>
      Additional nights and/or items are chargeable. 若超过限定的殡葬礼仪服务或者额外的物品，公司将附加收费。

    </v-flex>
    <v-flex>
      Items listed are subjected to change without prior notice and may be substituted with an item of similar value at
    the company’s sole discretion. 所列项⽬如有更改，恕不另⾏通知，公司⾃⾏决定并可能取代同等价值的项⽬。
    </v-flex>
    <v-flex>
      Some items are on rental basis. 某些物品是以出租模式进⾏。

    </v-flex>
    <v-flex>
      Payment via cash or cheque only. 付款⽅式只限于现⾦和⽀票。

    </v-flex>
    <v-flex>
      The company shall not be liable for any direct, indirect or consequential losses in the event that the specified hearse or vehicle is not available as a result of circumstances beyond its control, provided that an alternative mode of conveyance or transport is made available. 任何由于某些⽆可预測的缘故或是发⽣任何超出公司所能控制的状况，即使指定的灵⻋或交通⼯具⽆法被使⽤，公司将有权以其他运输或交通⽅式代替，⽽⽆需承担任何责任。
    </v-flex>
    <v-flex>
      All prices are inclusive of 7%GST. 价格包括7%消费税。

    </v-flex>
    <v-flex>
      All prices listed are in Singapore dollars. 价格都以新元计算。

    </v-flex>
  </v-flex>
</template>

<script>
  export default {
    mounted () {
      console.log(this.$vuetify.breakpoint)
    }
  }
</script>



// WEBPACK FOOTER //
// DfsServiceAgreement.vue?d9865db0